var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-loader"},[_c('q-inner-loading',{attrs:{"showing":""}},[_c('q-spinner',{attrs:{"size":"50px","color":"secondary"}}),_c('span',{staticClass:"message"},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }